import { ServiceBase } from '../../../../../../core/services/ServiceBase'
import SectorPerformanceProxy from './SectorPerformanceProxy'

class SectorPerformanceService extends ServiceBase {
  getFdiDomestic(params) {
    return this.getData(() => SectorPerformanceProxy.getFdiDomestic(params))
  }

  getLargeSme(params) {
    return this.getData(() => SectorPerformanceProxy.getLargeSme(params))
  }

  getListedLarge(params) {
    return this.getData(() => SectorPerformanceProxy.getListedLarge(params))
  }

  sectorDefaultVsicIdPerformanceAnalyzerExport(params) {
    return this.getFileDownload(() =>
      SectorPerformanceProxy.sectorDefaultVsicIdPerformanceAnalyzerExport(
        params,
      ),
    )
  }

  sectorDefaultVsicIdPerformanceAnalyzerCompareExport(params) {
    return this.getFileDownload(() =>
      SectorPerformanceProxy.sectorDefaultVsicIdPerformanceAnalyzerCompareExport(
        params,
      ),
    )
  }
}

export default new SectorPerformanceService()
